import { render } from "./About.vue?vue&type=template&id=64fc0674"
const script = {}
script.render = render

export default script